import styles from './Rules.module.scss';
import {
	Spacer,
	Label,
	Radio,
	ContentExpander,
	InfoChip
} from '@components';
import { useRateCardRulesState } from '@hooks';
import { CHIP_TYPE, RateCardType, TRateCardRules } from '@types';
import { ChangeEvent } from 'react';

type TProps = {
	isSettings?: boolean;
	isDisabled?: boolean;
	type?: RateCardType;
}

export const PriceRules = (props: TProps) => {
	const {
		isSettings = false,
		isDisabled = false,
		type
	} = props;
	const [rateCardRules, setRateCardRules] = useRateCardRulesState();
	const rules = isSettings ? rateCardRules.settings : rateCardRules.rateCard;

	const updateRules = (e: ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target;
		let newVal;
		if (name === 'disable_take_now_price') {
			newVal = value === 'no';
		} else {
			newVal = value === 'yes';
		}
		const update = {
			...rules,
			[name]: newVal
		} as TRateCardRules
		const newRules = {
			settings: isSettings ? update : undefined,
			rateCard: !isSettings ? update : undefined
		}
		setRateCardRules(newRules);
	}

	return (
		<ContentExpander
			title={<div className={styles.expanderTitle}>Pricing rules</div>}
			showSpacer={false}
			expanded={false}
			arrowsAsExpanderIcon
			iconColor='var(--neutral-06)'
		>
			<Spacer size={0} divider />
			<div className={styles.expanderContent}>
				{
					type !== 'ITEM' ?
						<>
							<Spacer size={15} />
							<Label>Allow 'Take now' price in Marketplace for this rate card</Label>
							<Spacer size={5} />
							<Radio.Group className={styles.row}>
								<Radio
									label={'Yes'}
									name={'disable_take_now_price'}
									value={'yes'}
									onChange={updateRules}
									checked={!rules?.disable_take_now_price}
									disabled={isDisabled}
								/>
								<Radio
									label={'No'}
									name={'disable_take_now_price'}
									value={'no'}
									onChange={updateRules}
									checked={rules?.disable_take_now_price === true}
									disabled={isDisabled}
								/>
							</Radio.Group>
						</> : null
				}
				<Spacer size={15} />
				<Label>Consolidate units and apply higher unit range price</Label>
				<Spacer size={5} />
				<Radio.Group className={styles.row}>
					<Radio
						label={'Yes'}
						name={'allow_consolidation'}
						value={'yes'}
						onChange={updateRules}
						checked={rules?.allow_consolidation === true}
						disabled={isDisabled}
					/>
					<Radio
						label={'No'}
						name={'allow_consolidation'}
						value={'no'}
						onChange={updateRules}
						checked={!rules?.allow_consolidation}
						disabled={isDisabled}
					/>
				</Radio.Group>
				<Spacer size={10} />
				<InfoChip type={CHIP_TYPE.INFO} text='eg: If the Shipper makes 3 x 5 pallet space bookings and they are consolidated, we will charge them the 15 pallet space range price.' />
			</div>
		</ContentExpander>
	);
}
